<template>
  <div id="popup-awards" class="popup__main">
    <div class="popup__header">
      <a href="#" class="popup__close" @click.prevent="closePopup"></a>
    </div>
    <div class="popup__content">
      <div class="chart">
        <img src="../assets/images/popup_chart-1.png" alt="" />
        <!-- <picture>
          <source
            srcset="../assets/images/popup_chart-1_m.png"
            media="(max-width: 1080px)"
          />
          <img src="../assets/images/popup_chart-1.png" alt="" />
        </picture> -->
      </div>
      <div class="secure-text">
        資料來源：Lipper、商周Smart智富、中國信託投信整理，淨值走勢區間是自基金於2016/06/08成立以來至2025/05/31。*本基金I/A(USD)、R/A(USD)級別成立日期均為2016/06/08。欲查詢完整得獎紀錄，請詳見<span
          class="word-break"
          >https://www.ctbcinvestments.com/About/OutsidePartner。</span
        ><span class="highlight"
          >本基金非為保本型或保證型投資策略，非定存之替代品，亦不保證收益分配[如有]之金額與本金之全額返還，最大可能損失則為全部投資金額。以上指數為含息報酬指數，僅供參考用途，其歷史績效不應被視為現在或未來表現及績效的保證，亦不代表基金現在或未來之報酬率。
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'PopupAwards',
  data: () => {
    return {};
  },
  computed: {
    ...mapState(useMainStore, ['popup']),
  },
  methods: {
    ...mapActions(useMainStore, ['closePopup']),
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
#popup-awards {
  .popup__content {
    .chart {
      width: 100%;
      max-width: 1200px;
      // height: 615px;
      @include tabletX {
        width: 90%;
      }
      @include tablet {
        overflow-x: auto;
        width: vwM(1000);
        // height: vwM(840);
        // margin-left: vwM(62);
      }
      img {
        width: 1107px;
        height: 592px;
        // @include tabletX {
        //   width: vwX(1107);
        //   height: vwX(592);
        // }
        @include tablet {
          width: vwM(1350);
          height: vwM(722);
        }
      }
    }
    .secure-text {
      color: #3f3f3f;
      a {
        display: inline-block;
        color: #3f3f3f;
      }
      .highlight {
        color: #009eb5;
      }
    }
  }
  .word-break {
    word-break: break-all;
    overflow-wrap: break-word;
  }
}
</style>
